import React from 'react';

import AdminProjects from './adminProjects.js';
import AdminRates from './adminRates.js';
import AdminClients from './adminClients.js';
import AdminEmployees from './adminEmployees.js';
import AdminMaterials from './adminMaterials.js';
import AdminWorkdays from './adminWorkdays.js';

function AdminSection() {

    return (
        <div
            id="admin-content"
            className="content-block"
            style={{ border: 'none', boxShadow: 'none' }}>

            {/* <!-- admin search bar --> */}
            <div
                id="search-container"
                className="search-container">

                <input 
                    className="search-input"
                    id="search-input"
                    onClick={() => { console.log('search-admin') }}
                    placeholder="&nbsp;&nbsp;search here..."
                />

                {/* <!-- <button 
                    className="search-button"
                    id="search-button">
                    button
                </button> --> */}
                
            </div>

            {/* <!-- admin tab menu --> */}
            <div
                id="admin-menu"
                className="admin-menu">

                {/* <!-- Projects menu selection --> */}
                <p 
                    id="admin-menu-text-projects"
                    className="admin-menu-text tab-line"
                    onClick={() => {
                        // move tab-line class to underline menu selection 
                        document.getElementById('admin-menu-text-projects').classList.add('tab-line')
                        document.getElementById('admin-menu-text-rates').classList.remove('tab-line')
                        document.getElementById('admin-menu-text-clients').classList.remove('tab-line')
                        document.getElementById('admin-menu-text-employees').classList.remove('tab-line')
                        document.getElementById('admin-menu-text-materials').classList.remove('tab-line')
                        document.getElementById('admin-menu-text-workdays').classList.remove('tab-line')
                        // show appropriate view per menu selection 
                        document.getElementById('container-admin-content-projects').style.visibility='visible';
                        document.getElementById('container-admin-content-projects').style.display='block';
                        document.getElementById('container-admin-content-rates').style.visibility='hidden';
                        document.getElementById('container-admin-content-rates').style.display='none';
                        document.getElementById('container-admin-content-clients').style.visibility='hidden';
                        document.getElementById('container-admin-content-clients').style.display='none';
                        document.getElementById('container-admin-content-employees').style.visibility='hidden';
                        document.getElementById('container-admin-content-employees').style.display='none';
                        document.getElementById('container-admin-content-materials').style.visibility='hidden';
                        document.getElementById('container-admin-content-materials').style.display='none';
                        document.getElementById('container-admin-content-workdays').style.visibility='hidden';
                        document.getElementById('container-admin-content-workdays').style.display='none';
                    }}>
                    Projects
                </p>

                <p className="admin-menu-separator"></p>

                {/* <!-- Rates menu selection --> */}
                <p 
                    id="admin-menu-text-rates"
                    className="admin-menu-text"
                    onClick={() => {
                        document.getElementById('admin-menu-text-projects').classList.remove('tab-line')
                        document.getElementById('admin-menu-text-rates').classList.add('tab-line')
                        document.getElementById('admin-menu-text-clients').classList.remove('tab-line')
                        document.getElementById('admin-menu-text-employees').classList.remove('tab-line')
                        document.getElementById('admin-menu-text-materials').classList.remove('tab-line')
                        document.getElementById('admin-menu-text-workdays').classList.remove('tab-line')
                        // show appropriate view per menu selection 
                        document.getElementById('container-admin-content-rates').style.visibility='visible'
                        document.getElementById('container-admin-content-rates').style.display='block'
                        document.getElementById('container-admin-content-projects').style.visibility='hidden';
                        document.getElementById('container-admin-content-projects').style.display='none';
                        document.getElementById('container-admin-content-clients').style.visibility='hidden';
                        document.getElementById('container-admin-content-clients').style.display='none';
                        document.getElementById('container-admin-content-employees').style.visibility='hidden';
                        document.getElementById('container-admin-content-employees').style.display='none';
                        document.getElementById('container-admin-content-materials').style.visibility='hidden';
                        document.getElementById('container-admin-content-materials').style.display='none';
                        document.getElementById('container-admin-content-workdays').style.visibility='hidden';
                        document.getElementById('container-admin-content-workdays').style.display='none';
                    }}>
                    Rates
                </p>

                <p className="admin-menu-separator"></p>

                {/* <!-- Clients menu selection --> */}
                <p 
                    id="admin-menu-text-clients"
                    className="admin-menu-text"
                    onClick={() => {
                        // move tab-line class to underline menu selection 
                        document.getElementById('admin-menu-text-projects').classList.remove('tab-line')
                        document.getElementById('admin-menu-text-rates').classList.remove('tab-line')
                        document.getElementById('admin-menu-text-clients').classList.add('tab-line')
                        document.getElementById('admin-menu-text-employees').classList.remove('tab-line')
                        document.getElementById('admin-menu-text-materials').classList.remove('tab-line')
                        document.getElementById('admin-menu-text-workdays').classList.remove('tab-line')
                        // show appropriate view per menu selection 
                        document.getElementById('container-admin-content-clients').style.visibility='visible';
                        document.getElementById('container-admin-content-clients').style.display='block';
                        document.getElementById('container-admin-content-projects').style.visibility='hidden';
                        document.getElementById('container-admin-content-projects').style.display='none';
                        document.getElementById('container-admin-content-rates').style.visibility='hidden';
                        document.getElementById('container-admin-content-rates').style.display='none';
                        document.getElementById('container-admin-content-employees').style.visibility='hidden';
                        document.getElementById('container-admin-content-employees').style.display='none';
                        document.getElementById('container-admin-content-materials').style.visibility='hidden';
                        document.getElementById('container-admin-content-materials').style.display='none';
                        document.getElementById('container-admin-content-workdays').style.visibility='hidden';
                        document.getElementById('container-admin-content-workdays').style.display='none';
                    }}>
                    Clients
                </p>

                <p className="admin-menu-separator"></p>

                {/* <!-- Employees menu selection --> */}
                <p 
                    id="admin-menu-text-employees"
                    className="admin-menu-text"
                    onClick={() => {
                        // move tab-line class to underline menu selection 
                        document.getElementById('admin-menu-text-projects').classList.remove('tab-line')
                        document.getElementById('admin-menu-text-rates').classList.remove('tab-line')
                        document.getElementById('admin-menu-text-clients').classList.remove('tab-line')
                        document.getElementById('admin-menu-text-employees').classList.add('tab-line')
                        document.getElementById('admin-menu-text-materials').classList.remove('tab-line')
                        document.getElementById('admin-menu-text-workdays').classList.remove('tab-line')
                        // show appropriate view per menu selection 
                        document.getElementById('container-admin-content-employees').style.visibility='visible';
                        document.getElementById('container-admin-content-employees').style.display='block';
                        document.getElementById('container-admin-content-projects').style.visibility='hidden';
                        document.getElementById('container-admin-content-projects').style.display='none';
                        document.getElementById('container-admin-content-rates').style.visibility='hidden';
                        document.getElementById('container-admin-content-rates').style.display='none';
                        document.getElementById('container-admin-content-clients').style.visibility='hidden';
                        document.getElementById('container-admin-content-clients').style.display='none';
                        document.getElementById('container-admin-content-materials').style.visibility='hidden';
                        document.getElementById('container-admin-content-materials').style.display='none';
                        document.getElementById('container-admin-content-workdays').style.visibility='hidden';
                        document.getElementById('container-admin-content-workdays').style.display='none';
                    }}>
                    Employees
                </p>

                <p className="admin-menu-separator"></p>

                {/* <!-- Materials menu selection --> */}
                <p 
                    id="admin-menu-text-materials"
                    className="admin-menu-text"
                    onClick={() => {
                        // move tab-line class to underline menu selection 
                        document.getElementById('admin-menu-text-projects').classList.remove('tab-line')
                        document.getElementById('admin-menu-text-rates').classList.remove('tab-line')
                        document.getElementById('admin-menu-text-clients').classList.remove('tab-line')
                        document.getElementById('admin-menu-text-employees').classList.remove('tab-line')
                        document.getElementById('admin-menu-text-materials').classList.add('tab-line')
                        document.getElementById('admin-menu-text-workdays').classList.remove('tab-line')
                        // show appropriate view per menu selection 
                        document.getElementById('container-admin-content-materials').style.visibility='visible';
                        document.getElementById('container-admin-content-materials').style.display='block';
                        document.getElementById('container-admin-content-projects').style.visibility='hidden';
                        document.getElementById('container-admin-content-projects').style.display='none';
                        document.getElementById('container-admin-content-rates').style.visibility='hidden';
                        document.getElementById('container-admin-content-rates').style.display='none';
                        document.getElementById('container-admin-content-clients').style.visibility='hidden';
                        document.getElementById('container-admin-content-clients').style.display='none';
                        document.getElementById('container-admin-content-employees').style.visibility='hidden';
                        document.getElementById('container-admin-content-employees').style.display='none';
                        document.getElementById('container-admin-content-workdays').style.visibility='hidden';
                        document.getElementById('container-admin-content-workdays').style.display='none';
                    }}>
                    Materials
                </p>

                <p className="admin-menu-separator"></p>

                {/* <!-- Workdays menu selection --> */}
                <p 
                    id="admin-menu-text-workdays"
                    className="admin-menu-text"
                    onClick={() => {
                        // move tab-line class to underline menu selection 
                        document.getElementById('admin-menu-text-projects').classList.remove('tab-line')
                        document.getElementById('admin-menu-text-rates').classList.remove('tab-line')
                        document.getElementById('admin-menu-text-clients').classList.remove('tab-line')
                        document.getElementById('admin-menu-text-employees').classList.remove('tab-line')
                        document.getElementById('admin-menu-text-materials').classList.remove('tab-line')
                        document.getElementById('admin-menu-text-workdays').classList.add('tab-line')
                        // show appropriate view per menu selection 
                        document.getElementById('container-admin-content-workdays').style.visibility='visible';
                        document.getElementById('container-admin-content-workdays').style.display='block';
                        document.getElementById('container-admin-content-projects').style.visibility='hidden';
                        document.getElementById('container-admin-content-projects').style.display='none';
                        document.getElementById('container-admin-content-rates').style.visibility='hidden';
                        document.getElementById('container-admin-content-rates').style.display='none';
                        document.getElementById('container-admin-content-clients').style.visibility='hidden';
                        document.getElementById('container-admin-content-clients').style.display='none';
                        document.getElementById('container-admin-content-employees').style.visibility='hidden';
                        document.getElementById('container-admin-content-employees').style.display='none';
                        document.getElementById('container-admin-content-materials').style.visibility='hidden';
                        document.getElementById('container-admin-content-materials').style.display='none';
                    }}>
                    Workdays
                </p>

            </div>

            {/* Admin Projects */}
            <div
                id="container-admin-content-projects"
                className="container-admin-content"
                style={{ display: 'block', visibility: 'visible'}}>
                <AdminProjects/>
            </div>

            {/* Admin Rates */}
            <div
                id="container-admin-content-rates"
                className="container-admin-content">
                <AdminRates/>
            </div>

            {/* Admin Clients */}
            <div
                id="container-admin-content-clients"
                className="container-admin-content">
                <AdminClients/>
            </div>

            {/* Admin Employees */}
            <div
                id="container-admin-content-employees"
                className="container-admin-content"> 
                <AdminEmployees/>
            </div>

            {/* Admin Materials */}
            <div
                id="container-admin-content-materials"
                className="container-admin-content">  
                <AdminMaterials/>
            </div>

            {/* Admin Workdays */}
            <div
                id="container-admin-content-workdays"
                className="container-admin-content">
                <AdminWorkdays/>
            </div>

        </div>
    )
}

export default AdminSection;
